import { useId } from 'react';

export type Face = 'server' | 'client';

/**
 * returns information about rendered "face": server or client
 * It only can
 */
export const useFaceId = (): Face => {
	const id = useId();
	// server are `R` client are `r`
	// tests capturing "face check" are capturing this assumption
	return id[1] === 'R' ? 'server' : 'client';
};
